module.exports = __webpack_public_path__ + "img/banners.ce72c9c4.png";